module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e385836"
    }
  }, [_vm._v("Contents ")]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e395886"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c24_r1#d7ee1",
      "id": "d14e297"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e405936"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c25_r1#d7ee2",
      "id": "d14e300"
    }
  }, [_c('b', [_vm._v("1 ")]), _vm._v("All about Cake Mix")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e416046"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c26_r1#d7ee3",
      "id": "d14e305",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2 ")]), _vm._v("Classic Cakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e426136"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c27_r1#d7e1",
      "id": "d14e310",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bettered Box Mix ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e43d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c28_r1#d7e2",
      "id": "d14e313",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Buttermilk Cake Batter ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e44d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c29_r1#d7e3",
      "id": "d14e316",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Creamy White Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e45d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c30_r1#d7e4",
      "id": "d14e319",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Lemon Chiffonette Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e46d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c31_r1#d7e5",
      "id": "d14e322",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Nutty White Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e47d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c32_r1#d7e6",
      "id": "d14e325",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Classic Chocolate Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e48d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c33_r1#d7e7",
      "id": "d14e328",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Classic Strawberry Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e49d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c34_r1#d7e8",
      "id": "d14e332",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Italian Wedding Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e50d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c35_r1#d7e9",
      "id": "d14e335",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Devil’s Food Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e51d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c36_r1#d7e10",
      "id": "d14e338",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Neon Angel Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e52d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c37_r1#d7e11",
      "id": "d14e341",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate Bundt Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e53d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c38_r1#d7e12",
      "id": "d14e344",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Lemon Cooler Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e54d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c39_r1#d7e13",
      "id": "d14e347",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Earth Angel Food Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e55d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c40_r1#d7e14",
      "id": "d14e350",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate Chip Cookie Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e56d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c41_r1#d7e15",
      "id": "d14e353",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Peachy Yellow Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e57d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c42_r1#d7e16",
      "id": "d14e356",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Fluffiest Cake Ever ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e58d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c43_r1#d7e17",
      "id": "d14e359",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Simply Better Chocolate Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e59d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c44_r1#d7e18",
      "id": "d14e362",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Vanilla Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e60d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c45_r1#d7e19",
      "id": "d14e366",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Mega-Moist Chocolate Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e61d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c46_r1#d7e20",
      "id": "d14e369",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Simply Better Yellow Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e627336"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c47_r1#d7ee4",
      "id": "d6ee4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3 ")]), _vm._v("Birthday Cakes.")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e637446"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c48_r1#d7e21",
      "id": "d14e377",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baby’s First Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e64d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c49_r1#d7e22",
      "id": "d14e380",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Birthday Cake in a Cone ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e65d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c50_r1#d7e23",
      "id": "d14e383",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" PB&J Cupcakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e66d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c51_r1#d7e24",
      "id": "d14e386",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Birthday Cake with Sprinkles ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e67d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c52_r1#d7e25",
      "id": "d14e389",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Princess Pink Strawberry Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e68d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c53_r1#d7e26",
      "id": "d14e392",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Flower Pot Trifle ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e69d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c54_r1#d7e27",
      "id": "d14e395",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Belle of the Ball Fashion Doll Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e70d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c55_r1#d7e28",
      "id": "d14e398",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" All-American Burger Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e71d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c56_r1#d7e29",
      "id": "d14e402",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Yellow Pop Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e72d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c57_r1#d7e30",
      "id": "d14e405",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Birthday Cake Ice Cream ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e73d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c58_r1#d7e31",
      "id": "d14e408",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Peanut Butter Cup Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e74d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c59_r1#d7e32",
      "id": "d14e411",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Swirl Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e75d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c60_r1#d7e33",
      "id": "d14e414",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Lemony Birthday Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e76d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c61_r1#d7e34",
      "id": "d14e417",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Cookies and Cream Birthday Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e77d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c62_r1#d7e35",
      "id": "d14e420",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Tropical Birthday Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e78d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c63_r1#d7e36",
      "id": "d14e423",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Éclair Birthday Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e79d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c64_r1#d7e37",
      "id": "d14e426",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Pizza Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e80d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c65_r1#d7e38",
      "id": "d14e429",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Crust for Ice Cream Pie ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e81d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c66_r1#d7e39",
      "id": "d14e432",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Boston Crème Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e82d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c67_r1#d7e40",
      "id": "d14e436",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Black Forest Birthday Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e83d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c68_r1#d7e41",
      "id": "d14e439",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Cherry Cordial Birthday Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e848727"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c69_r1#d7ee5",
      "id": "d6ee5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4 ")]), _vm._v("Family Favorites ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e858817"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c70_r1#d7e42",
      "id": "d14e447",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chess Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e86d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c71_r1#d7e43",
      "id": "d14e450",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chess Cake Squares ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e87d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c72_r1#d7e44",
      "id": "d14e453",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Butter Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e88d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c73_r1#d7e45",
      "id": "d14e456",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Peachy Skillet Bake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e89d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c74_r1#d7e46",
      "id": "d14e459",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Harvest Fruit Bake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e90d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c75_r1#d7e47",
      "id": "d14e462",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Quickest Brownies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e91d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c76_r1#d7e48",
      "id": "d14e465",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Friendship Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e92d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c77_r1#d7e49",
      "id": "d14e468",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Creamy Coconut Dessert ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e93d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c78_r1#d7e50",
      "id": "d14e472",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Strawberry Shortcake Bake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e94d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c79_r1#d7e51",
      "id": "d14e475",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Sundae Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e95d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c80_r1#d7e52",
      "id": "d14e478",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate Gooey Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e96d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c81_r1#d7e53",
      "id": "d14e481",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Quick Bake Carrot Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e97d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c82_r1#d7e54",
      "id": "d14e484",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Lemon Goo Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e98d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c83_r1#d7e55",
      "id": "d14e487",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Candied Pumpkin Dessert ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e99d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c84_r1#d7e56",
      "id": "d14e490",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Playful Sprinkles Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e100d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c85_r1#d7e57",
      "id": "d14e493",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Peanut Butter Cup Fondue ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e101d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c86_r1#d7e58",
      "id": "d14e496",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Cantaloupe Squares ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e102d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c87_r1#d7e59",
      "id": "d14e499",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Raspberry Chocolate Bars ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e103d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c88_r1#d7e60",
      "id": "d14e502",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate Cherry Bars ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e104d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c89_r1#d7e61",
      "id": "d14e506",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate Fondue ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e105d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c90_r1#d7e62",
      "id": "d14e509",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Yellow Cake Dessert ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e106d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c91_r1#d7e63",
      "id": "d14e512",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Ricotta Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e107d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c92_r1#d7e64",
      "id": "d14e515",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Banana Bread ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e108d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c93_r1#d7e65",
      "id": "d14e518",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate Toffee Shortbread ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e109d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c94_r1#d7e66",
      "id": "d14e521",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Lemon Crunch Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e110d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c95_r1#d7e67",
      "id": "d14e524",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Lemon Crème Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e111d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c96_r1#d7e68",
      "id": "d14e527",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Sweet Potato Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e11210187"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c97_r1#d7ee6",
      "id": "d6ee6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5 ")]), _vm._v("Savory Surprises.")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e11310297"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c98_r1#d7e69",
      "id": "d14e535",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Tooth Cornbread Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e114d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c99_r1#d7e70",
      "id": "d14e538",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Cornbread Croutons ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e115d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c100_r1#d7e71",
      "id": "d14e542",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Ham, Beans, and Cornbread ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e116d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c101_r1#d7e72",
      "id": "d14e545",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Fruity Brunch Pizza ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e117d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c102_r1#d7e73",
      "id": "d14e548",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Dinner Rolls ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e118d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c103_r1#d7e74",
      "id": "d14e551",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Pizza Rolls ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e119d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c104_r1#d7e75",
      "id": "d14e554",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Peach Pecan Pizza ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e120d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c105_r1#d7e76",
      "id": "d14e557",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Mexican Chili Pie ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e121d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c106_r1#d7e77",
      "id": "d14e560",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Sweet Potato Fritters ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e122d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c107_r1#d7e78",
      "id": "d14e563",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Spoon Bread Casserole ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e123d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c108_r1#d7e79",
      "id": "d14e566",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Beef Pot Pie ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e124d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c109_r1#d7e80",
      "id": "d14e569",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Scalloped Corn Casserole ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e125d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c110_r1#d7e81",
      "id": "d14e572",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Breakfast Bake Casserole ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e126d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c111_r1#d7e82",
      "id": "d14e576",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Sweetest Hushpuppies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e127d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c112_r1#d7e83",
      "id": "d14e579",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Hamburger Cornbread Casserole ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e128d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c113_r1#d7e84",
      "id": "d14e582",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Sweet Potato Casserole ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e12911177"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c114_r1#d7ee7",
      "id": "d6ee7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6 ")]), _vm._v("Morning Glory Cakes.")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e13011297"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c115_r1#d7e85",
      "id": "d14e590",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rich Topped Coffee Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e131d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c116_r1#d7e86",
      "id": "d14e593",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Citrus Muffins ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e132d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c117_r1#d7e87",
      "id": "d14e596",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Cake Mix Pancakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e133d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c118_r1#d7e88",
      "id": "d14e599",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Better Buttermilk Breakfast Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e134d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c119_r1#d7e89",
      "id": "d14e602",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate Cheese Muffins ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e135d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c120_r1#d7e90",
      "id": "d14e605",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Easy as Apple Pie Muffins ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e136d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c121_r1#d7e91",
      "id": "d14e608",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Lemon Poppyseed Muffins ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e137d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c122_r1#d7e92",
      "id": "d14e612",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Warm Spice Muffins ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e138d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c123_r1#d7e93",
      "id": "d14e615",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Raspberry Muffins ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e139d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c124_r1#d7e94",
      "id": "d14e618",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Toasty Blueberry Loaf ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e140d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c125_r1#d7e95",
      "id": "d14e621",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Blueberry Muffin French Toast ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e141d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c126_r1#d7e96",
      "id": "d14e624",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Super-Easy Fruity Muffins ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e142d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c127_r1#d7e97",
      "id": "d14e627",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Banana-Nut Muffins ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e143d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c128_r1#d7e98",
      "id": "d14e630",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Healthier Brownie Muffins ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e144d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c129_r1#d7e99",
      "id": "d14e633",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Sweet Bran Muffins ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e145d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c130_r1#d7e100",
      "id": "d14e636",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Sweet Rolls ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e146d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c131_r1#d7e101",
      "id": "d14e639",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Cake Doughnuts ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e147d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c132_r1#d7e102",
      "id": "d14e642",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Apple Delight Brunch Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e148d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c133_r1#d7e103",
      "id": "d14e646",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Mandarin Orange Muffins ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e149d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c134_r1#d7e104",
      "id": "d14e649",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate Waffles ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e150d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c135_r1#d7e105",
      "id": "d14e652",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Piña Colada Sunrise Muffins ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e151d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c136_r1#d7e106",
      "id": "d14e655",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Tropical Angel Muffins ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e15212568"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c137_r1#d7ee8",
      "id": "d6ee8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7 ")]), _vm._v("Cooking for a Crowd ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e15312658"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c138_r1#d7e107",
      "id": "d14e663",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer on the Patio Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e154d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c139_r1#d7e108",
      "id": "d14e666",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Jack Horner’s Chocolate Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e155d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c140_r1#d7e109",
      "id": "d14e669",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Brownies for a Crowd ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e156d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c141_r1#d7e110",
      "id": "d14e672",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Lemon Sheet Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e157d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c142_r1#d7e111",
      "id": "d14e675",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Fruity Cake for a Crowd ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e158d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c143_r1#d7e112",
      "id": "d14e678",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Get-Together Coffee Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e159d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c144_r1#d7e113",
      "id": "d14e682",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Favorite Potluck Bars ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e160d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c145_r1#d7e114",
      "id": "d14e685",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Easy Black Forest Cobbler ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e161d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c146_r1#d7e115",
      "id": "d14e688",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Peach Cobbler ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e162d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c147_r1#d7e116",
      "id": "d14e691",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Cherry Tunnel Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e163d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c148_r1#d7e117",
      "id": "d14e694",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Fuzzy Navel Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e164d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c149_r1#d7e118",
      "id": "d14e697",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Amaretto Dream Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e165d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c150_r1#d7e119",
      "id": "d14e700",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Citrus Crush Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e166d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c151_r1#d7e120",
      "id": "d14e703",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Shortcake Trifle ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e167d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c152_r1#d7e121",
      "id": "d14e706",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Cheesecake for 24 ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e168d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c153_r1#d7e122",
      "id": "d14e709",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Pajama Party Pizza Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e169d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c154_r1#d7e123",
      "id": "d14e712",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Grown-Up Chocolate Trifle ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e170d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c155_r1#d7e124",
      "id": "d14e716",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Lower-Cholesterol Apple Bake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e171d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c156_r1#d7e125",
      "id": "d14e719",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Kahlua Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e172d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c157_r1#d7e126",
      "id": "d14e722",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Family-Friendly Punch Bowl Trifle ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e17313758"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c158_r1#d7ee9",
      "id": "d6ee9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8 ")]), _vm._v("Cooking with Kids ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e17413848"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c159_r1#d7e127",
      "id": "d14e730",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Toy Oven Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e175d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c160_r1#d7e128",
      "id": "d14e733",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Yummiest Play Dough Ever ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e176d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c161_r1#d7e129",
      "id": "d14e736",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Kisses from Kids Cupcakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e177d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c162_r1#d7e130",
      "id": "d14e739",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Heart-Shaped Cupcakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e178d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c163_r1#d7e131",
      "id": "d14e742",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Cake of Many Colors ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e179d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c164_r1#d7e132",
      "id": "d14e745",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Fortune Cupcakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e180d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c165_r1#d7e133",
      "id": "d14e748",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" No Bake Candy Treats ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e181d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c166_r1#d7e134",
      "id": "d14e752",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Easy Protein Cookies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e182d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c167_r1#d7e135",
      "id": "d14e755",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Campfire Cobbler ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e183d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c168_r1#d7e136",
      "id": "d14e758",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Orange Campfire Cakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e184d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c169_r1#d7e137",
      "id": "d14e761",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Microwave Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e185d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c170_r1#d7e138",
      "id": "d14e764",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Cinnamon Toast Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e186d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c171_r1#d7e139",
      "id": "d14e767",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Mardi Gras Cakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e187d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c172_r1#d7e140",
      "id": "d14e770",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Magic Potion Cookies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e188d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c173_r1#d7e141",
      "id": "d14e773",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Berry Snacky Pizza ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e189d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c174_r1#d7e142",
      "id": "d14e776",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Peanut Butter Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e190d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c175_r1#d7e143",
      "id": "d14e779",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Peanut Butter Icing ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e191d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c176_r1#d7e144",
      "id": "d14e782",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Four-Ingredient Apple Bake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e192d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c177_r1#d7e145",
      "id": "d14e786",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Choco-Cherry Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e193d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c178_r1#d7e146",
      "id": "d14e789",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Slow Cooker Cobbler ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e194d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c179_r1#d7e147",
      "id": "d14e792",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Mud Pie Cupcakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e195d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c180_r1#d7e148",
      "id": "d14e795",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Ice Cream Sandwiches with Sprinkles ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e19615098"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c181_r1#d7ee10",
      "id": "d6ee10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("9 ")]), _vm._v("Cake Mix Cookies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e19715198"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c182_r1#d7e149",
      "id": "d14e803",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blank Canvas Cookie Recipe ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e198d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c183_r1#d7e150",
      "id": "d14e806",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" German Chocolate Cake Cookies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e199d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c184_r1#d7e151",
      "id": "d14e809",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Oatmeal and Chocolate Chip Cookies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e200d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c185_r1#d7e152",
      "id": "d14e812",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Peanut Butter Cup Cookies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e201d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c186_r1#d7e153",
      "id": "d14e815",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Double-Devil Chocolate Crunch Cookies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e202d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c187_r1#d7e154",
      "id": "d14e818",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate Biscotti ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e203d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c188_r1#d7e155",
      "id": "d14e822",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Coconut Kisses ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e204d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c189_r1#d7e156",
      "id": "d14e825",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Butter-Pecan Cookies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e205d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c190_r1#d7e157",
      "id": "d14e828",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Peanut Butter Cookies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e206d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c191_r1#d7e158",
      "id": "d14e831",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Peanut Butter Kisses ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e207d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c192_r1#d7e159",
      "id": "d14e834",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Whipped Cream Brownie Bakers ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e208d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c193_r1#d7e160",
      "id": "d14e837",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Double Chocolate Chip Cookies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e209d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c194_r1#d7e161",
      "id": "d14e840",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Harvest Cookies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e210d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c195_r1#d7e162",
      "id": "d14e843",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Lemon-Lover’s Cookies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e211d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c196_r1#d7e163",
      "id": "d14e846",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Sandwich Cookies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e212d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c197_r1#d7e164",
      "id": "d14e849",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Lemon Squares ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e213d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c198_r1#d7e165",
      "id": "d14e852",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate and Strawberry Cookies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e214d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c199_r1#d7e166",
      "id": "d14e856",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Angel Food Cookies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e215d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c200_r1#d7e167",
      "id": "d14e859",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Best-Ever Brownies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e216d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c201_r1#d7e168",
      "id": "d14e862",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Lemon Mint Cookies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e217d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c202_r1#d7e169",
      "id": "d14e865",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Peanut Butter Tea Cakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e218d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c203_r1#d7e170",
      "id": "d14e868",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Richest Yellow Cake Cookies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e219d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c204_r1#d7e171",
      "id": "d14e871",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Granola White Chocolate Cookies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e220d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c205_r1#d7e172",
      "id": "d14e874",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Old Fashioned Sugar Cookies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e22116579"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c206_r1#d7ee11",
      "id": "d6ee11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("10 ")]), _vm._v("Cupcakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e22216669"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c207_r1#d7e173",
      "id": "d14e882",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coconut Cupcakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e223d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c208_r1#d7e174",
      "id": "d14e885",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate Cupcakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e224d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c209_r1#d7e175",
      "id": "d14e888",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Peanut Butter Cupcakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e225d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c210_r1#d7e176",
      "id": "d14e892",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Gooey Praline Cupcakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e226d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c211_r1#d7e177",
      "id": "d14e895",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Piña Colada Cupcakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e227d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c212_r1#d7e178",
      "id": "d14e898",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate Truffle Cupcakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e228d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c213_r1#d7e179",
      "id": "d14e901",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Perfect Lemon Cupcakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e229d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c214_r1#d7e180",
      "id": "d14e904",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate Chip Cupcakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e230d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c215_r1#d7e181",
      "id": "d14e907",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Cherry Cola Cupcakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e231d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c216_r1#d7e182",
      "id": "d14e910",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate Chip Red Velvet Cupcakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e232d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c217_r1#d7e183",
      "id": "d14e913",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" All-American Apple Pie Cupcakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e233d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c218_r1#d7e184",
      "id": "d14e916",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate-Filled Angel Cakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e234d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c219_r1#d7e185",
      "id": "d14e919",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate Sundae Cupcakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e235d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c220_r1#d7e186",
      "id": "d14e922",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Fresh Berry Cupcakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e236d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c221_r1#d7e187",
      "id": "d14e926",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Grande Ganache Cupcakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e237d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c222_r1#d7e188",
      "id": "d14e929",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Carrot Cake Cupcakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e238d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c223_r1#d7e189",
      "id": "d14e932",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Candied Apple Cupcakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e239d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c224_r1#d7e190",
      "id": "d14e935",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Brownie Cakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e240d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c225_r1#d7e191",
      "id": "d14e938",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" House Mouse Cupcakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e241d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c226_r1#d7e192",
      "id": "d14e941",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Rainy Day Cupcakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e242d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c227_r1#d7e193",
      "id": "d14e944",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Pudding-Topped Cupcakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e243d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c228_r1#d7e194",
      "id": "d14e947",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Whipping Cream ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e244d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c229_r1#d7e195",
      "id": "d14e950",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Strawberry Cheese Cupcakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e245d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c230_r1#d7e196",
      "id": "d14e953",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Berry Crème Cupcakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e24618039"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c231_r1#d7ee12",
      "id": "d6ee12",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("11 ")]), _vm._v("For Chocolate Lovers.")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e24718149"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c232_r1#d7e197",
      "id": "d14e962",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ultra-Chocolate Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e248d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c233_r1#d7e198",
      "id": "d14e965",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Rich Chocolate Bundt Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e249d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c234_r1#d7e199",
      "id": "d14e968",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate Upside-Down Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e250d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c235_r1#d7e200",
      "id": "d14e971",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Classic Chocolate Trifle ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e251d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c236_r1#d7e201",
      "id": "d14e974",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate Sandwich Cookies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e252d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c237_r1#d7e202",
      "id": "d14e977",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Cocoa-Cola Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e253d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c238_r1#d7e203",
      "id": "d14e980",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Hot Chocolate Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e254d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c239_r1#d7e204",
      "id": "d14e983",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Micro-Mug Cake for One ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e255d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c240_r1#d7e205",
      "id": "d14e986",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Sweet Layers Chocolate Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e256d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c241_r1#d7e206",
      "id": "d14e989",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Lower-Fat Chocolate Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e257d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c242_r1#d7e207",
      "id": "d14e992",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Crock-o-Late Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e258d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c243_r1#d7e208",
      "id": "d14e996",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Sandwich Cookie Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e259d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c244_r1#d7e209",
      "id": "d14e999",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Sandwich Cookie Cake Frosting ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e260d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c245_r1#d7e210",
      "id": "d14e1002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Coconaise Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e261d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c246_r1#d7e211",
      "id": "d14e1005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Movie Night Brownies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e262d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c247_r1#d7e212",
      "id": "d14e1008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate Cake Batter Ice Cream ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e263d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c248_r1#d7e213",
      "id": "d14e1011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Malt Shoppe Chocolate Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e264d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c249_r1#d7e214",
      "id": "d14e1014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Turtle Skillet Cakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e265d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c250_r1#d7e215",
      "id": "d14e1017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolaty Coconut Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e266d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c251_r1#d7e216",
      "id": "d14e1020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate Zucchini Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e267d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c252_r1#d7e217",
      "id": "d14e1023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Mexican Chocolate Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e268d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c253_r1#d7e218",
      "id": "d14e1026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate Latte Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e269d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c254_r1#d7e219",
      "id": "d14e1030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Peanut Butter Fudge Brownies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e270d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c255_r1#d7e220",
      "id": "d14e1033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate Angel Cakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e271d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c256_r1#d7e221",
      "id": "d14e1036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Mocha Mud Bundt Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e27219629"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c257_r1#d7ee13",
      "id": "d6ee13",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("12 ")]), _vm._v("Holiday Favorites ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e27319729"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c258_r1#d7e222",
      "id": "d14e1044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fruitcake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e274d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c259_r1#d7e223",
      "id": "d14e1047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Rum Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e275d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c260_r1#d7e224",
      "id": "d14e1050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Rum Cake Glaze ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e276d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c261_r1#d7e225",
      "id": "d14e1053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Minute Macaroons ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e277d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c262_r1#d7e226",
      "id": "d14e1056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Cherry Sugar Plums ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e278d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c263_r1#d7e227",
      "id": "d14e1059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Kitschy Pixie Poke Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e279d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c264_r1#d7e228",
      "id": "d14e1062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Day-Glo Valentine Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e280d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c265_r1#d7e229",
      "id": "d14e1066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate-Covered-Cherry Brownies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e281d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c266_r1#d7e230",
      "id": "d14e1069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Green Beer Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e282d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c267_r1#d7e231",
      "id": "d14e1072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Leprechaun Cupcakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e283203010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c268_r1#d7e232",
      "id": "d14e1075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Top o’ the Cupcake to You Icing ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e284d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c269_r1#d7e233",
      "id": "d14e1078",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Sparkling Lavender Garden Party Cupcakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e285d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c270_r1#d7e234",
      "id": "d14e1081",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Easter Coconut Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e286d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c271_r1#d7e235",
      "id": "d14e1084",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Summer Celebration Berry Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e287d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c272_r1#d7e236",
      "id": "d14e1087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Pesach Banana Cake for Passover ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e288d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c273_r1#d7e237",
      "id": "d14e1090",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Dulce de Leche Cream Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e289d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c274_r1#d7e238",
      "id": "d14e1093",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Great Pumpkin Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e290d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c275_r1#d7e239",
      "id": "d14e1096",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Pumpkin Patch Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e291d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c276_r1#d7e240",
      "id": "d14e1100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Thanksgiving Pie Dump Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e292d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c277_r1#d7e241",
      "id": "d14e1103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Pecan Pie Casserole ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e293d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c278_r1#d7e242",
      "id": "d14e1106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Fresh from the Bog Cranberry Cobbler ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e294d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c279_r1#d7e243",
      "id": "d14e1109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Cranberry Bundt Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e295d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c279.1_r1#d7e244",
      "id": "d14e1112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Cranberry Cream Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e296211510"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c280_r1#d7ee14",
      "id": "d6ee14",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("13 ")]), _vm._v("Local and Organic ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e297212410"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c281_r1#d7e245",
      "id": "d14e1120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Organic Carrot Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e298d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c282_r1#d7e246",
      "id": "d14e1123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Turnip Spice Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e299d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c283_r1#d7e247",
      "id": "d14e1126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Rhubarb Upside-Down Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e300d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c284_r1#d7e248",
      "id": "d14e1129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Easy Rhubarb Upside-Down Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e301d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c285_r1#d7e249",
      "id": "d14e1132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Strawberry-Rhubarb Crumble ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e302d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c286_r1#d7e250",
      "id": "d14e1136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Sauerkraut Black Forest Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e303d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c287_r1#d7e251",
      "id": "d14e1139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate Beet Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e304d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c288_r1#d7e252",
      "id": "d14e1142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Pumpkin Bread ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e305d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c289_r1#d7e253",
      "id": "d14e1145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Baking Pumpkin ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e306d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c290_r1#d7e254",
      "id": "d14e1148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Spicy Squash Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e307d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c290.1_r1#d7e255",
      "id": "d14e1151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Fresh Berry Lemon Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e308d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c291_r1#d7e256",
      "id": "d14e1154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Harvest Squash Cobbler ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e309d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c292_r1#d7e257",
      "id": "d14e1157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Sunshine State Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e310d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c293_r1#d7e258",
      "id": "d14e1160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Juiciest Poke Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e311d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c294_r1#d7e259",
      "id": "d14e1163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" A Is for Apple Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e312d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c295_r1#d7e260",
      "id": "d14e1166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Ginny Sawyer’s Freezer Preserves ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e313d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c296_r1#d7e261",
      "id": "d14e1170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Farmers’ Market Trifle ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e314d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c297_r1#d7e262",
      "id": "d14e1173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Organic Grasshopper Brownies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e315d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c297.1_r1#d7e263",
      "id": "d14e1176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Fruit Stand Jam Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e316d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c298_r1#d7e264",
      "id": "d14e1179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Zucchini Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e317d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c299_r1#d7e265",
      "id": "d14e1182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Smoothie Splash Pound Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e318224210"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c300_r1#d7ee15",
      "id": "d6ee15",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("14 ")]), _vm._v("Vegetarian Cakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e319225110"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c301_r1#d7e266",
      "id": "d14e1190",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DIY Vegan Cake Mix ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e320d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c302_r1#d7e267",
      "id": "d14e1193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Super Quick Vegan Cookies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e321d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c303_r1#d7e268",
      "id": "d14e1196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Vegan Pumpkin Cookies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e322d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c304_r1#d7e269",
      "id": "d14e1199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Vegan Yellow Cake Sugar Cookies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e323d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c305_r1#d7e270",
      "id": "d14e1202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Famous Vegan Fizz Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e324d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c306_r1#d7e271",
      "id": "d14e1206",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Vegan Chocolate Fizz Bundt Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e325d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c307_r1#d7e272",
      "id": "d14e1209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Vegan Bundt Cake Glaze ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e326d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c308_r1#d7e273",
      "id": "d14e1212",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Vegan Cherry Cola Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e327d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c309_r1#d7e274",
      "id": "d14e1215",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Vegan Spice Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e328d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c310_r1#d7e275",
      "id": "d14e1218",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Fancy Red Fizz Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e329d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c311_r1#d7e276",
      "id": "d14e1221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate Pumpkin Muffins ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e330d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c312_r1#d7e277",
      "id": "d14e1224",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Vegan Vanilla Icing ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e331d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c313_r1#d7e278",
      "id": "d14e1227",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Vegan Chocolate Frosting ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e332d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c314_r1#d7e279",
      "id": "d14e1230",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Vegan Dump Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e333d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c315_r1#d7e280",
      "id": "d14e1233",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Vegan Applesauce Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e334d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c316_r1#d7e281",
      "id": "d14e1236",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Sugar Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e335d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c317_r1#d7e282",
      "id": "d14e1240",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Sugar Cake Topping ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e336d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c318_r1#d7e283",
      "id": "d14e1243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Vegan Brownie Bites ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e337d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c319_r1#d7e284",
      "id": "d14e1246",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Eggless Yellow Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e338d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c320_r1#d7e285",
      "id": "d14e1249",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Vegan Strawberry Shortcake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e339241311"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c321_r1#d7ee16",
      "id": "d6ee16",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("15 ")]), _vm._v("Special Diets and Allergies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e340242211"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c322_r1#d7e286",
      "id": "d14e1257",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic DIY Cake Mix ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e341d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c323_r1#d7e287",
      "id": "d14e1260",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Yellow Cake from DIY Mix ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e342d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c324_r1#d7e288",
      "id": "d14e1263",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" White Cake from DIY Mix ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e343d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c325_r1#d7e289",
      "id": "d14e1266",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Spice Cake from DIY Mix ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e344d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c326_r1#d7e290",
      "id": "d14e1269",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Strawberry Cake from DIY Mix ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e345d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c327_r1#d7e291",
      "id": "d14e1272",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" “Flour” to Make Gluten-Free DIY Cake Mix ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e346d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c328_r1#d7e292",
      "id": "d14e1276",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Dye- and Milk-Free Chocolate Frosting ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e347d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c329_r1#d7e293",
      "id": "d14e1279",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" No-Dye Red Velvet Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e348d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c330_r1#d7e294",
      "id": "d14e1282",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate Cake from DIY Mix ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e349d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c331_r1#d7e295",
      "id": "d14e1285",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Cherrybrook Kitchen’s Chocolate Cake with Raspberry Filling ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e350d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c332_r1#d7e296",
      "id": "d14e1288",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Gluten-Free Vanilla Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e351d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c333_r1#d7e297",
      "id": "d14e1291",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Allergy-Friendly Icing ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e352d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c334_r1#d7e298",
      "id": "d14e1294",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Sugar-Free Frosting ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e353d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c335_r1#d7e299",
      "id": "d14e1297",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Gluten-Free Peach Cobbler ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e354d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c336_r1#d7e300",
      "id": "d14e1300",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Diabetic-Friendly Hearth-Spice Angel Food Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e355d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c337_r1#d7e301",
      "id": "d14e1303",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Diabetic Carrot Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e356d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c338_r1#d7e302",
      "id": "d14e1306",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Diabetic Lemon Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e357d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c339_r1#d7e303",
      "id": "d14e1310",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Egg- and Dairy-Free Yellow Cake ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e358d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c340_r1#d7e304",
      "id": "d14e1313",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Orangey Angel Cookies ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e359d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c341_r1#d7e305",
      "id": "d14e1316",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Diabetic-Friendly Sweet Treat ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e360254911"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c342_r1#d7ee17",
      "id": "d6ee17",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("A ")]), _vm._v("Cake Decorating ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e361255811"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c342_r1#d7e457038048265",
      "id": "d14e1324",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Tools and Techniques ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e362d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c342_r1#d7e457638234266",
      "id": "d14e1327",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Dusting and Stenciling Techniques ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e363d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c342_r1#d7e458438347267",
      "id": "d14e1330",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate Drizzles ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e364d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c342_r1#d7e459238448267",
      "id": "d14e1333",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Piping ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e365d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c342_r1#d7e460038546268",
      "id": "d14e1336",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Filigree ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e366d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c342_r1#d7e460638627269",
      "id": "d14e1339",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Appliqués ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e367d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c342_r1#d7e461638724269",
      "id": "d14e1342",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Grated Chocolate ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e368d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c342_r1#d7e462138773270",
      "id": "d14e1346",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Shaved Chocolate ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e369d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c342_r1#d7e463038879270",
      "id": "d14e1349",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate Curls ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e370d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c342_r1#d7e463739009271",
      "id": "d14e1352",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Striped Chocolate Curls ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e371d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c342_r1#d7e464539117272",
      "id": "d14e1355",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Feathered Chocolate Curls ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e372d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c342_r1#d7e465239195272",
      "id": "d14e1358",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Marbled Chocolate Curls ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e373d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c342_r1#d7e465839250273",
      "id": "d14e1361",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate Fans ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e374d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c342_r1#d7e466339308273",
      "id": "d14e1364",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate Leaves ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e375d7e442"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c342_r1#d7e467039388274",
      "id": "d14e1367",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Chocolate Cutouts ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e376264211"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c343_r1#d7ee18",
      "id": "d6ee18",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("B ")]), _vm._v("Substitutions and Conversions ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e377265211"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c345_r1#d7ee19",
      "id": "d6ee19",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("C ")]), _vm._v("Glossary ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e378266111"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Sawy_9781605506579_epub_c346_r1#d7ee20",
      "id": "d6ee20",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("D ")]), _vm._v("Resources")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e361374","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sawy_9781605506579_epub_c22_r1.vue
// module id = 78
// module chunks = 0